// import { Link } from "gatsby";
// import React from "react";
// import Card from "@material-ui/core/Card";

// import Button from "../../components/Button";
// import Grid from "@material-ui/core/Grid";
// import PlainCard from "../PlainCard"
// import "./PlainCardWithHover.scss";

// // const IndividualBox = (props) => {
// //   return (
// //     <Link
// //       style={{ textDecoration: "none", color: "black" }}
// //       to={props.PlainCardWithHoverData.route}
// //     >
// //               <Grid className="mt-50 body-container" container direction="row" spacing={3}>
// //               <Grid
// //             item
// //             xs={12}
// //             sm={12}
// //             md={4}
// //             className="card crd-spc"
// //           >  
// //             <Card className="appsgridshadow">

// //       <div className="individual-box">
// //         <div>
// //           <div className="individual-box-title">
// //             {props.PlainCardWithHoverData.title}
// //           </div>
// //           <div className="individual-box-sub-title">
// //             {props.PlainCardWithHoverData.subTitle}
// //           </div>
// //           {/* <div className="individual-box-button">
// //             <Button
// //               customClassName="individual-box-btn"
// //               variant={props.PlainCardWithHoverData.IndividualBoxBtnVariant}
// //               color={props.PlainCardWithHoverData.IndividualBoxBtnColor}
// //               label={props.PlainCardWithHoverData.IndividualBoxBtnLabel}
// //               routepath={props.PlainCardWithHoverData.route}
// //             />
// //           </div> */}
// //         </div>
// //       </div>
// //       </Card>
// //       <PlainCard
// //               HoverCardWithBtnCustomClass="hover-card-bg-odd"
// //               pageName={props.pageName}
// //               HoverCardWithBtntitle={
// //                 props.PlainCardWithHoverData.HoverCardWithBtntitle1
// //               }
// //               HoverCardWithBtnIcon={
// //                 props.PlainCardWithHoverData.HoverCardWithBtnIcon1
// //               }
// //               HoverCardWithBtnContent={
// //                 props.PlainCardWithHoverData.HoverCardWithBtnContent1
// //               }
// //               HoverCardWithBtnIconAlt={
// //                 props.PlainCardWithHoverData.HoverCardWithBtnIconAlt1
// //               }
// //               HoverCardIconClass={props.HoverCardIconClass}
// //               HoverCardWithBtnContentClass={props.HoverCardWithBtnContentClass}
// //             />
// //       </Grid>
// //       </Grid>
// //     </Link>
// //   );
// // };

// export default IndividualBox;

import React, { useState } from "react";
import { Link } from "gatsby";
 import Grid from "@material-ui/core/Grid";

// import "./SimpleImage.scss";

const  SimpleImage = (props) => {
    const [over, setOver] = useState(false);
    const [hoverState1, sethoverState1] = useState(false);
    const [hoverState2, sethoverState2] = useState(false);
    const [hoverState3, sethoverState3] = useState(false);
 return(
//     <Grid className="mt-50 body-container" container direction="row" spacing={3}>

//     {props.imageData.data.map((item, index) => (

//     <Link
//           style={{ textDecoration: "none", color: "black" }}
//           to={props.PlainCardWithHoverData.route}
//         >
//               <Grid
//             item
//             xs={12}
//             sm={12}
//             md={4}
//             // className="card crd-spc"
//           >  
// <div
//       onMouseOver={() => setOver(true)}
//       onMouseOut={() => setOver(false)}
//     >
//           <img
// src={over ? item.imgHover : item.image}
// />
// </div> 
// </Grid>
// </Link>
//      ) )}
       <Grid className="mt-50 body-container" container direction="row" spacing={3}>
        <React.Fragment> <Grid
            // key={index}
            item
            xs={12}
            sm={12}
            md={4}
            className="card crd-spc"
          >
              <span
      onMouseEnter={() => sethoverState1(true)}
      onMouseLeave={() => {
        sethoverState1(false);
        sethoverState2(false);
        sethoverState3(false);
      }}    >
          <Link target="_blank" className="services-link" to={props.imageData.route1}>
   
    {!hoverState1 &&   <img
src={ props.imageData.image1}
style={{width:'100%'}}
/> }
{hoverState1 && <img
src={ props.imageData.imgHover1}
style={{width:'100%'}}
/> }
</Link>
  </span> </Grid>
  <Grid
//   key={index}
  item
  xs={12}
  sm={12}
  md={4}
  className="card crd-spc"
>
  <span
      onMouseEnter={() => sethoverState2(true)}
      onMouseLeave={() => {
        sethoverState1(false);
        sethoverState2(false);
        sethoverState3(false);
      }}    >
            <Link target="_blank" className="services-link" to={props.imageData.route2}>
     
    {!hoverState2 &&   <img
src={ props.imageData.image2}
style={{width:'100%'}}
/> }
{hoverState2 && <img
src={ props.imageData.imgHover2}
style={{width:'100%'}}
/> }
</Link>
  </span> </Grid>
  <Grid
//   key={index}
  item
  xs={12}
  sm={12}
  md={4}
  className="card crd-spc"
>
  <span
      onMouseEnter={() => sethoverState3(true)}
      onMouseLeave={() => {
        sethoverState1(false);
        sethoverState2(false);
        sethoverState3(false);
      }}    >
            <Link target="_blank" className="services-link" to={props.imageData.route3}>
     
    {!hoverState3 &&   <img
src={ props.imageData.image3}
style={{width:'100%'}}
/> }
{hoverState3 && <img
src={ props.imageData.imgHover3}
style={{width:'100%'}}
/> }
</Link>
  </span> 
    </Grid></React.Fragment> 
    
     </Grid>
 )
}

export default SimpleImage;